// src/pages/servicesDataStore.js
import api from "../api";
import config from "../config";

export async function loadServices() {
  try {
    const res = await api.get("getCategoryWithSubCategory");
    const rawServices = Array.isArray(res.data?.data) ? res.data.data : [];

    return rawServices.map((service) => ({
      category_id: service.category_id || "",
      commission: service.commission || "",
      category: service.category || "",
      title: service.title || "",
      description: service.description || "",
      price: service.price || "",
      icon: service.icon
        ? config.baseUrl + service.icon
        : "https://via.placeholder.com/50",
      rating: service.rating || "",
      subServices: Array.isArray(service.subServices)
        ? service.subServices.map((sub) => ({
            name: sub.name || "",
            price: sub.price || "",
          }))
        : [],
    }));
  } catch (err) {
    console.error("API Error:", err);
    return [];
  }
}
